import { useNavigate } from 'react-router-dom';

import logo from '../assets/logo/ams-logo.png';

interface IProps {
  closeMobileSideMenu: () => void;
}

const Logo = ({ closeMobileSideMenu }: IProps) => {
  const navigate = useNavigate();

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '242px',
        cursor: 'pointer',
      }}
      onClick={() => {
        closeMobileSideMenu();
        navigate('/');
      }}
    >
      <div style={{ width: '54px', height: '49px', userSelect: 'none' }}>
        <img src={logo} alt="logo" style={{ width: '100%' }} />
      </div>

      <div style={{ marginLeft: '12px', textAlign: 'left', fontFamily: 'Poppins' }}>
        <div
          style={{
            marginBottom: '10px',
            fontSize: '42px',
            lineHeight: '26px',
            userSelect: 'none',
          }}
        >
          AMS
        </div>
        <div style={{ fontSize: '10px', letterSpacing: '2px', userSelect: 'none' }}>
          Agent Management System
        </div>
      </div>
    </div>
  );
};

export default Logo;
